import { render } from "./price-period-list.vue?vue&type=template&id=6cdd942d"
import script from "./price-period-list.vue?vue&type=script&lang=js"
export * from "./price-period-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__